import { FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../../../common/hooks/useStyles';
import { getReplayVideoStyleObject, getTooltipMarginLeft } from './replayVideo.style';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { ToolTip } from '../../../common/components/toolTip/toolTip';
import { getReplayVideoId, getReplayVideoTooltipId } from '../htmlElements/htmlElementsIdGetter';
import { TOOLTIP_TITLES } from '../controlsPlugin.constants';
import { TOOLTIP_POSITIONS } from '../../../common/components/toolTip/toolTip.contants';
import { Icon } from '../../../common/components/icon/icon';
import { CONTROLS_ICON_TYPES } from '../icon/iconMapper';
import { replayVideo } from '../store/controlsPlugin.actions';
import { isDesktopMode } from '../../../common/utils/utils';
import { discoverySelector } from '../../../common/store/selectors/discovery.selector';

const ARIA_LABEL = 'Replay';

export const ReplayVideo: FunctionComponent = () => {
  const dispatch = useDispatch();
  const playerMode = useSelector(playerDataSelector.playerMode);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const nextVideo = useSelector(discoverySelector.nextVideo);

  const desktopMode = isDesktopMode(playerMode);
  const showReplayBigCenterIcon = nextVideo !== 'upNext';

  const styles = useStyles(getReplayVideoStyleObject, [playerSize, showReplayBigCenterIcon]);
  const { replayBigCenterIconStyle, replayTopLeftIconStyle, iconAndToolTipContainerStyle, screenStyle } = styles;

  const onClickIcon = (): void => {
    dispatch(replayVideo());
  };

  const ReplayVideoIcon: FunctionComponent = () => (
    <Icon
      id={getReplayVideoId(playerUniqueId)}
      icon={showReplayBigCenterIcon ? CONTROLS_ICON_TYPES.REPLAY_BLUR : CONTROLS_ICON_TYPES.REPLAY_FILL}
      style={showReplayBigCenterIcon ? replayBigCenterIconStyle : replayTopLeftIconStyle}
      onClick={onClickIcon}
      ariaLabel={ARIA_LABEL}
    />
  );

  return (
    <div style={screenStyle}>
      {desktopMode
        ? (
          <div style={iconAndToolTipContainerStyle}>
            <ToolTip
              id={getReplayVideoTooltipId(playerUniqueId)}
              content={TOOLTIP_TITLES.REPLAY_VIDEO}
              position={showReplayBigCenterIcon ? TOOLTIP_POSITIONS.TOP : TOOLTIP_POSITIONS.BOTTOM_RIGHT}
              variables={{ marginLeft: showReplayBigCenterIcon ? '0px' : getTooltipMarginLeft(playerSize) }}
            >
              <ReplayVideoIcon />
            </ToolTip>
          </div>
        )
        : (
          <ReplayVideoIcon />
        )}
    </div>
  );
};
